import VGListener from "./src/vg";
import YaCounter from './src/modules/analytics/ym';

(function ($) {
	let scrollScheduled = false;
	let resizeScheduled = false;

	$(window).on('load', function() {
		VGListener.onLoad();
	});

	$(window).scroll(function () {
		if (scrollScheduled) {
			return;
		}

		scrollScheduled = true;
		window.requestAnimationFrame(() => {
			VGListener.onScroll($(window));
			scrollScheduled = false;
		});
	});

	$(document).ready(function () {
		VGListener.onReady();
	});

	$(window).resize(function () {
		if (resizeScheduled) {
			return;
		}

		resizeScheduled = true;
		window.requestAnimationFrame(() => {
			VGListener.onResize($(window));
			resizeScheduled = false;
		});
	});
})(jQuery);

// Modules
require ('./src/modules/social');
require('./src/modules/analytics/analytics');
require('./src/modules/analytics/jivo');
require('./src/modules/bg');
require('./src/modules/video');
require('./src/modules/map');
require('./src/modules/catalog/catalog');
require('./src/modules/maintenance-alert');
require('./src/modules/yandex_smart_captcha/listeners');
require('./src/modules/forms/forms');
require('./src/modules/ui/sidebar_in_modal');
require('./src/utils/spy/spy');

window.bootstrap = window.vgp = require('../../../modules/index.esm');

window.ymetrika = new YaCounter();

// [[vegas]]
